/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDentalTooths } from 'app/entities/dental-tooth/dental-tooth.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getMedicalHistories } from 'app/entities/medical-history/medical-history.reducer';
import { getEntities as getDentalExamAndTreatments } from 'app/entities/dental-exam-and-treatment/dental-exam-and-treatment.reducer';
import { createEntity, getEntity, reset, updateEntity } from './dental-mouth-item.reducer';

export const DentalMouthItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dentalTooths = useAppSelector(state => state.dentalTooth.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const medicalHistories = useAppSelector(state => state.medicalHistory.entities);
  const dentalExamAndTreatments = useAppSelector(state => state.dentalExamAndTreatment.entities);
  const dentalMouthItemEntity = useAppSelector(state => state.dentalMouthItem.entity);
  const loading = useAppSelector(state => state.dentalMouthItem.loading);
  const updating = useAppSelector(state => state.dentalMouthItem.updating);
  const updateSuccess = useAppSelector(state => state.dentalMouthItem.updateSuccess);

  const handleClose = () => {
    navigate(`/dental-mouth-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDentalTooths({}));
    dispatch(getGlucoUsers({}));
    dispatch(getMedicalHistories({}));
    dispatch(getDentalExamAndTreatments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);
  const toNumberIfDefined = value => (value !== undefined && typeof value !== 'number' ? Number(value) : value);

  const saveEntity = values => {
    // List of fields that need to be converted to numbers
    const numberFields = [
      'mobility',
      'fork1',
      'fork2',
      'fork3',
      'bleeding1',
      'bleeding2',
      'bleeding3',
      'bleeding4',
      'bleeding5',
      'bleeding6',
      'plaque1',
      'plaque2',
      'plaque3',
      'plaque4',
      'plaque5',
      'plaque6',
      'gum',
      'examinedDate',
      'cursor',
      'lastupdated',
      'microSec',
      'timestampentry',
    ];

    // Convert each specified field in values to a number if necessary
    numberFields.forEach(field => {
      values[field] = toNumberIfDefined(values[field]);
    });

    // Create the entity with merged values and relationships
    const entity = {
      ...dentalMouthItemEntity,
      ...values,
      tooth: dentalTooths.find(it => it.id.toString() === values.tooth?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      medicalHistory: medicalHistories.find(it => it.id.toString() === values.medicalHistory?.toString()),
      exam: dentalExamAndTreatments.find(it => it.id.toString() === values.exam?.toString()),
    };

    // Dispatch the action based on whether it's a new entity
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...dentalMouthItemEntity,
          tooth: dentalMouthItemEntity?.tooth?.id,
          patient: dentalMouthItemEntity?.patient?.id,
          medicalHistory: dentalMouthItemEntity?.medicalHistory?.id,
          exam: dentalMouthItemEntity?.exam?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dentalMouthItem.home.createOrEditLabel" data-cy="DentalMouthItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.home.createOrEditLabel">Create or edit a DentalMouthItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dental-mouth-item-id"
                  label={translate('tinyMedicRestApp.dentalMouthItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.available')}
                id="dental-mouth-item-available"
                name="available"
                data-cy="available"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.implant')}
                id="dental-mouth-item-implant"
                name="implant"
                data-cy="implant"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.mobility')}
                id="dental-mouth-item-mobility"
                name="mobility"
                data-cy="mobility"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.fork1')}
                id="dental-mouth-item-fork1"
                name="fork1"
                data-cy="fork1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding1')}
                id="dental-mouth-item-bleeding1"
                name="bleeding1"
                data-cy="bleeding1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding2')}
                id="dental-mouth-item-bleeding2"
                name="bleeding2"
                data-cy="bleeding2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding3')}
                id="dental-mouth-item-bleeding3"
                name="bleeding3"
                data-cy="bleeding3"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding4')}
                id="dental-mouth-item-bleeding4"
                name="bleeding4"
                data-cy="bleeding4"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding5')}
                id="dental-mouth-item-bleeding5"
                name="bleeding5"
                data-cy="bleeding5"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.bleeding6')}
                id="dental-mouth-item-bleeding6"
                name="bleeding6"
                data-cy="bleeding6"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque1')}
                id="dental-mouth-item-plaque1"
                name="plaque1"
                data-cy="plaque1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque2')}
                id="dental-mouth-item-plaque2"
                name="plaque2"
                data-cy="plaque2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque3')}
                id="dental-mouth-item-plaque3"
                name="plaque3"
                data-cy="plaque3"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque4')}
                id="dental-mouth-item-plaque4"
                name="plaque4"
                data-cy="plaque4"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque5')}
                id="dental-mouth-item-plaque5"
                name="plaque5"
                data-cy="plaque5"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.plaque6')}
                id="dental-mouth-item-plaque6"
                name="plaque6"
                data-cy="plaque6"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.gum')}
                id="dental-mouth-item-gum"
                name="gum"
                data-cy="gum"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin1')}
                id="dental-mouth-item-margin1"
                name="margin1"
                data-cy="margin1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin2')}
                id="dental-mouth-item-margin2"
                name="margin2"
                data-cy="margin2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin3')}
                id="dental-mouth-item-margin3"
                name="margin3"
                data-cy="margin3"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin4')}
                id="dental-mouth-item-margin4"
                name="margin4"
                data-cy="margin4"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin5')}
                id="dental-mouth-item-margin5"
                name="margin5"
                data-cy="margin5"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.margin6')}
                id="dental-mouth-item-margin6"
                name="margin6"
                data-cy="margin6"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth1')}
                id="dental-mouth-item-depth1"
                name="depth1"
                data-cy="depth1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth2')}
                id="dental-mouth-item-depth2"
                name="depth2"
                data-cy="depth2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth3')}
                id="dental-mouth-item-depth3"
                name="depth3"
                data-cy="depth3"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth4')}
                id="dental-mouth-item-depth4"
                name="depth4"
                data-cy="depth4"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth5')}
                id="dental-mouth-item-depth5"
                name="depth5"
                data-cy="depth5"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.depth6')}
                id="dental-mouth-item-depth6"
                name="depth6"
                data-cy="depth6"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.fork2')}
                id="dental-mouth-item-fork2"
                name="fork2"
                data-cy="fork2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.fork3')}
                id="dental-mouth-item-fork3"
                name="fork3"
                data-cy="fork3"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.notes')}
                id="dental-mouth-item-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.treatments')}
                id="dental-mouth-item-treatments"
                name="treatments"
                data-cy="treatments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.examinedDate')}
                id="dental-mouth-item-examinedDate"
                name="examinedDate"
                data-cy="examinedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.active')}
                id="dental-mouth-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.cursor')}
                id="dental-mouth-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.lastupdated')}
                id="dental-mouth-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.microSec')}
                id="dental-mouth-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalMouthItem.timestampentry')}
                id="dental-mouth-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="dental-mouth-item-tooth"
                name="tooth"
                data-cy="tooth"
                label={translate('tinyMedicRestApp.dentalMouthItem.tooth')}
                type="select"
                required
              >
                <option value="" key="0" />
                {dentalTooths
                  ? dentalTooths.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="dental-mouth-item-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.dentalMouthItem.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="dental-mouth-item-medicalHistory"
                name="medicalHistory"
                data-cy="medicalHistory"
                label={translate('tinyMedicRestApp.dentalMouthItem.medicalHistory')}
                type="select"
              >
                <option value="" key="0" />
                {medicalHistories
                  ? medicalHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="dental-mouth-item-exam"
                name="exam"
                data-cy="exam"
                label={translate('tinyMedicRestApp.dentalMouthItem.exam')}
                type="select"
              >
                <option value="" key="0" />
                {dentalExamAndTreatments
                  ? dentalExamAndTreatments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dental-mouth-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DentalMouthItemUpdate;
